<template>
    <div class="row font-20 font-medium justify-center mb-3">Thông tin nhóm thẻ</div>

    <DxValidationGroup ref="formValidation">
        <div class="row">
            <div class="xs12">
                <DxSelectBox
                    label="Loại thẻ (*)"
                    v-model="ThongTinNhomThe.IdLoaiThe"
                    :dataSource="{
                        store: DanhSachLoaiThe,
                        pageSize: 20,
                        paginate: true,
                    }"
                    display-expr="TenLoaiThe"
                    value-expr="IdLoaiThe"
                    :search-enabled="true"
                    styling-mode="outlined"
                    no-data-text="Không có dữ liệu!"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                    </DxValidator>
                </DxSelectBox>
            </div>
        </div>
        <div class="row mt-5">
            <div class="xs12">
                <DxTextBox
                    label="Tên nhóm thẻ (*)"
                    v-model="ThongTinNhomThe.TenNhomThe"
                    styling-mode="outlined"
                    validationMessageMode="always"
                    labelMode="floating"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                        <DxStringLengthRule
                            :max="128"
                            message="Không được vượt quá 128 ký tự!"
                        />
                    </DxValidator>
                </DxTextBox>
            </div>
        </div>
    </DxValidationGroup>

    <div class="row justify-space-between mt-3">
        <DxButton
            type="danger"
            text="Đóng"
            styling-mode="text"
            width="96px"
            @click="Dong"
        />
        <DxButton
            key="mdi-XACNHAN"
            type="default"
            text="Lưu thông tin"
            styling-mode="contained"
            @click="LuuThongTin()"
        />
    </div>
</template>
<script>
import {
    DxTextBox,
    DxSelectBox,
    DxValidationGroup,
    DxButton,
    DxValidator,
} from "devextreme-vue";
import {
    DxRequiredRule,
    DxStringLengthRule,
    DxNumericRule,
} from "devextreme-vue/validator";

export default {
    components: {
        DxSelectBox,
        DxTextBox,
        DxValidationGroup,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxStringLengthRule,
        DxNumericRule,
    },
    data() {
        return {
            DanhSachDoanhNghiep: [],
        };
    },
    computed: {
        ThongTinNhomThe: {
            get() {
                return this.$store.state.NhomThe.ThongTinNhomThe;
            },
            set(data) {
                this.$store.commit("NhomThe/Set", {
                    key: "ThongTinNhomThe",
                    data: data,
                });
            },
        },
        DanhSachLoaiThe() {
            return this.$store.state.NhomThe.DanhSachLoaiThe;
        },
    },
    methods: {
        Dong() {
            this.$emit("hiddenPopup", "PopupThongTinNhomThe");
        },
        LuuThongTin() {
            let validate = this.$refs.formValidation.instance.validate();
            if (!validate.isValid) {
                return this.$Helper.Common.autoFocusError(validate);
            }
            this.ThucHienLuuThongTin();
        },
        async ThucHienLuuThongTin() {
            try {
                this.$startLoading;
                let rs;
                if (!this.ThongTinNhomThe.IdNhomThe) {
                    rs = await this.$store.dispatch("NhomThe/TaoMoiNhomThe");
                } else {
                    rs = await this.$store.dispatch("NhomThe/CapNhatNhomThe");
                }
                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Lưu thông tin nhóm thẻ thành công!"
                    );
                    this.Dong();
                    this.$emit("getData");
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Lưu thông tin nhóm thẻ thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                console.log("🚀 ~ error:", error);
                this.$Helper.ThongBaoPopup({
                    message_title: "Lưu thông tin nhóm thẻ thất bại!",
                    message: "Lỗi hệ thống client.",
                });
            } finally {
                this.$stopLoading;
            }
        },
        async LayDanhSachLoaiThe() {
            try {
                this.$startLoading;
                await this.$store.dispatch("NhomThe/LayDanhSachLoaiThe");
            } catch (error) {
                console.log("🚀 ~ error", error);
            } finally {
                this.$stopLoading;
            }
        },
    },
    created() {
        this.LayDanhSachLoaiThe();
    },
    mounted() {},
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
